<template>
  <div
    v-if="isVisible"
    class="modex-banner"
  >
    <div class="modex-content">
      <div class="modex-brand-section">
        <img
          class="reelables-logo"
          :src="logo"
          :height="40"
          alt="Reelables logo"
        >
        <img
          src="https://www.modexshow.com/images/MX-logo.png"
          alt="MODEX 2026 Logo"
          class="modex-logo"
        >
        <div class="modex-text">
          <p>
            <strong>Find us at Modex</strong>
          </p>
          <p
            v-if="boothNumber"
            class="booth-text"
          >
            {{ boothNumber }}
          </p>
        </div>
      </div>

      <div class="modex-actions">
        <span
          v-if="boothNumber"
          class="booth-badge"
        >{{ boothNumber }}</span>
        <button
          v-if="hasButton"
          class="banner-button"
          @click="clickButton"
        >
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import LogoImage from '../../../assets/images/reelables-r-logo-white.svg';

export default {
  name: 'ModexBanner',
  props: {
    boothNumber: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isVisible: true,
    };
  },
  computed: {
    logo() {
      return LogoImage;
    },
    hasButton() {
      return !!this.buttonText;
    },
  },
  methods: {
    clickButton() {
      this.$emit('button-click');
    },
  },
};
</script>

<style scoped>
.modex-banner {
  position: absolute;
  top: 0;
  background: linear-gradient(90deg, #1C21AA 0%, #3339B5 100%);
  color: #ffffff;
  padding: 8px;
  border-bottom: 3px solid #d4af37; /* Gold accent border */
  font-family: Arial, sans-serif;
  width: 100%;
  z-index: 10;
}

.modex-content {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modex-brand-section {
  display: flex;
  align-items: center;
  gap: 20px;
}

.modex-logo {
  height: 35px; /* Adjust height as needed */
  width: auto;
  filter: brightness(0) invert(1); /* Forces logo to be white for better contrast */
  margin-left: -8px;
}

.reelables-logo {
  margin-left: -8px;
}

.modex-text p {
  margin: 0;
  font-size: 14px;
}

.details {
  display: block;
  font-size: 12px;
  color: #cbd5e0;
}

.modex-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.booth-text {
  display: none;
}

.booth-badge {
  background-color: #d4af37;
  color: #000;
  padding: 3px 8px;
  font-weight: bold;
  font-size: 12px;
  border-radius: 2px;
}

.banner-button {
  background-color: #ffffff;
  color: #002e5d;
  padding: 6px 14px;
  text-decoration: none;
  font-weight: bold;
  font-size: 13px;
  border-radius: 4px;
  transition: 0.2s ease-in-out;
}

.banner-button:hover {
  background-color: #d4af37;
  color: #ffffff;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .modex-logo {
    height: 25px;
  }
  .details {
    display: inline;
    margin-left: 5px;
  }
  .modex-text p {
    font-size: 12px;
  }
  .booth-text {
    display: block;
  }
  .booth-badge {
    display: none; /* Hide booth on small mobile to save space */
  }
}
</style>
